import { render, staticRenderFns } from "./IM_2_4.vue?vue&type=template&id=f46efb6c&scoped=true&"
import script from "./IM_2_4.vue?vue&type=script&lang=js&"
export * from "./IM_2_4.vue?vue&type=script&lang=js&"
import style0 from "./IM_2_4.vue?vue&type=style&index=0&id=f46efb6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46efb6c",
  null
  
)

export default component.exports